module.exports = __webpack_public_path__ + "static/vf_mshorts_core.9a085b20.svg";